import { Image, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { CustomPrimaryButton } from 'components/Buttons';

import { responsiveSize } from 'theme/helpers';

export const Container = styled.div`
    padding: ${responsiveSize(24, 84)} ${responsiveSize(16, 56)} ${responsiveSize(16, 56)};
    overflow: hidden;
`;

export const Title = styled(Text)`
    font-size: ${responsiveSize(24, 84)};
    line-height: ${responsiveSize(32, 112)};
    margin-bottom: ${responsiveSize(12, 42)};
`;

export const Subtitle = styled(Text)<{ $mb: boolean }>`
    font-size: ${responsiveSize(16, 56)};
    line-height: ${responsiveSize(24, 84)};
    margin-bottom: ${({ $mb }) => ($mb ? responsiveSize(24, 84) : responsiveSize(16, 56))};
    white-space: pre-line;
`;

export const Emoji = styled(Image)`
    width: ${responsiveSize(32, 132)};
    margin-bottom: ${responsiveSize(20, 72)};
`;

export const StyledButton = styled(CustomPrimaryButton)`
    padding: ${responsiveSize(20, 72)};
`;

export const ButtonText = styled(Text)`
    font-size: ${responsiveSize(17, 60)};
    line-height: ${responsiveSize(24, 28)};
`;
